import React from 'react';

export const TAG_ICON = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.25 4.25H4.2575H4.25ZM4.25 1.25H8C8.384 1.25 8.768 1.39625 9.0605 1.6895L14.3105 6.9395C14.5917 7.22079 14.7497 7.60225 14.7497 8C14.7497 8.39775 14.5917 8.77921 14.3105 9.0605L9.0605 14.3105C8.77921 14.5917 8.39775 14.7497 8 14.7497C7.60225 14.7497 7.22079 14.5917 6.9395 14.3105L1.6895 9.0605C1.55 8.92139 1.43937 8.75609 1.36394 8.5741C1.28852 8.39211 1.2498 8.197 1.25 8V4.25C1.25 3.45435 1.56607 2.69129 2.12868 2.12868C2.69129 1.56607 3.45435 1.25 4.25 1.25V1.25Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CHEVRON_UP = (
  <svg width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.498869 5.7991C0.658267 5.95845 0.874429 6.04797 1.09982 6.04797C1.32521 6.04797 1.54137 5.95845 1.70077 5.7991L4.49982 3.00005L7.29887 5.7991C7.37728 5.88028 7.47107 5.94504 7.57477 5.98958C7.67848 6.03413 7.79002 6.05758 7.90288 6.05856C8.01574 6.05954 8.12767 6.03804 8.23213 5.9953C8.33659 5.95256 8.4315 5.88944 8.5113 5.80963C8.59111 5.72983 8.65423 5.63492 8.69697 5.53046C8.73971 5.426 8.76121 5.31407 8.76023 5.20121C8.75925 5.08835 8.7358 4.97681 8.69126 4.8731C8.64671 4.7694 8.58195 4.67561 8.50077 4.5972L5.10077 1.1972C4.94137 1.03785 4.72521 0.94833 4.49982 0.94833C4.27443 0.94833 4.05827 1.03785 3.89887 1.1972L0.498869 4.5972C0.339518 4.7566 0.25 4.97276 0.25 5.19815C0.25 5.42354 0.339518 5.6397 0.498869 5.7991Z"
      fill="#333333"
    />
  </svg>
);

export const CHEVRON_DOWN = (
  <svg width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.498869 1.2009C0.658267 1.04155 0.874429 0.952033 1.09982 0.952033C1.32521 0.952033 1.54137 1.04155 1.70077 1.2009L4.49982 3.99995L7.29887 1.2009C7.37728 1.11972 7.47107 1.05496 7.57477 1.01042C7.67848 0.965867 7.79002 0.942419 7.90288 0.941438C8.01574 0.940458 8.12767 0.961964 8.23213 1.0047C8.33659 1.04744 8.4315 1.11056 8.5113 1.19037C8.59111 1.27017 8.65423 1.36508 8.69697 1.46954C8.73971 1.574 8.76121 1.68593 8.76023 1.79879C8.75925 1.91165 8.7358 2.02319 8.69126 2.1269C8.64671 2.2306 8.58195 2.32439 8.50077 2.4028L5.10077 5.8028C4.94137 5.96215 4.72521 6.05167 4.49982 6.05167C4.27443 6.05167 4.05827 5.96215 3.89887 5.8028L0.498869 2.4028C0.339518 2.2434 0.25 2.02724 0.25 1.80185C0.25 1.57646 0.339518 1.3603 0.498869 1.2009Z"
      fill="#333333"
    />
  </svg>
);

export const CHEVRON_LEFT = (
  <svg width="10" height="15" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.55608 7.49026L10 1.83398L8.08877 2.27912e-08L0.907419 7.49035L8.08877 15L10 13.166L4.55608 7.49026Z"
      fill="white"
    />
  </svg>
);

export const NEW_CHEVRON_LEFT = (
  <svg width="10" height="15" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.55608 7.49026L10 1.83398L8.08877 2.27912e-08L0.907419 7.49035L8.08877 15L10 13.166L4.55608 7.49026Z"
      fill="#333"
    />
  </svg>
);

export const ADD_TEST_CASE_ICON = (
  <svg width="56" height="16" viewBox="0 0 56 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.21122 13.544H4.5L5 14.5295H0.981931C0.040931 14.5295 -0.237212 14.0583 0.205895 13.3042L4.92536 5.47761V0.985536H3.99411C3.29754 0.985536 3.29754 0 3.99411 0H10.7773C11.4739 0 11.4739 0.985536 10.7773 0.985536H9.84607V5.47761L11 7.5H10L8.8474 5.72939V0.985536H5.92404V5.72939L1.21122 13.544Z"
      fill="#00447B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.71436 16C10.7752 16 11.7926 15.5786 12.5428 14.8284C13.2929 14.0783 13.7144 13.0609 13.7144 12C13.7144 10.9391 13.2929 9.92172 12.5428 9.17157C11.7926 8.42143 10.7752 8 9.71436 8C8.65349 8 7.63607 8.42143 6.88593 9.17157C6.13578 9.92172 5.71436 10.9391 5.71436 12C5.71436 13.0609 6.13578 14.0783 6.88593 14.8284C7.63607 15.5786 8.65349 16 9.71436 16ZM10.2144 10.5C10.2144 10.3674 10.1617 10.2402 10.0679 10.1464C9.97414 10.0527 9.84696 10 9.71436 10C9.58175 10 9.45457 10.0527 9.3608 10.1464C9.26703 10.2402 9.21436 10.3674 9.21436 10.5V11.5H8.21436C8.08175 11.5 7.95457 11.5527 7.8608 11.6464C7.76703 11.7402 7.71436 11.8674 7.71436 12C7.71436 12.1326 7.76703 12.2598 7.8608 12.3536C7.95457 12.4473 8.08175 12.5 8.21436 12.5H9.21436V13.5C9.21436 13.6326 9.26703 13.7598 9.3608 13.8536C9.45457 13.9473 9.58175 14 9.71436 14C9.84696 14 9.97414 13.9473 10.0679 13.8536C10.1617 13.7598 10.2144 13.6326 10.2144 13.5V12.5H11.2144C11.347 12.5 11.4741 12.4473 11.5679 12.3536C11.6617 12.2598 11.7144 12.1326 11.7144 12C11.7144 11.8674 11.6617 11.7402 11.5679 11.6464C11.4741 11.5527 11.347 11.5 11.2144 11.5H10.2144V10.5Z"
      fill="#00447B"
    />
    <path
      d="M22.751 9.14453H19.7725L19.1035 11H18.1367L20.8516 3.89062H21.6719L24.3916 11H23.4297L22.751 9.14453ZM20.0557 8.37305H22.4727L21.2617 5.04785L20.0557 8.37305ZM24.9873 8.31445C24.9873 7.50391 25.1794 6.85286 25.5635 6.36133C25.9476 5.86654 26.4505 5.61914 27.0723 5.61914C27.6908 5.61914 28.1807 5.83073 28.542 6.25391V3.5H29.4453V11H28.6152L28.5713 10.4336C28.21 10.8763 27.707 11.0977 27.0625 11.0977C26.4505 11.0977 25.9508 10.847 25.5635 10.3457C25.1794 9.8444 24.9873 9.1901 24.9873 8.38281V8.31445ZM25.8906 8.41699C25.8906 9.01595 26.0143 9.4847 26.2617 9.82324C26.5091 10.1618 26.8509 10.3311 27.2871 10.3311C27.86 10.3311 28.2783 10.0739 28.542 9.55957V7.13281C28.2718 6.63477 27.8568 6.38574 27.2969 6.38574C26.8542 6.38574 26.5091 6.55664 26.2617 6.89844C26.0143 7.24023 25.8906 7.74642 25.8906 8.41699ZM30.6318 8.31445C30.6318 7.50391 30.8239 6.85286 31.208 6.36133C31.5921 5.86654 32.0951 5.61914 32.7168 5.61914C33.3353 5.61914 33.8252 5.83073 34.1865 6.25391V3.5H35.0898V11H34.2598L34.2158 10.4336C33.8545 10.8763 33.3516 11.0977 32.707 11.0977C32.0951 11.0977 31.5954 10.847 31.208 10.3457C30.8239 9.8444 30.6318 9.1901 30.6318 8.38281V8.31445ZM31.5352 8.41699C31.5352 9.01595 31.6589 9.4847 31.9062 9.82324C32.1536 10.1618 32.4954 10.3311 32.9316 10.3311C33.5046 10.3311 33.9229 10.0739 34.1865 9.55957V7.13281C33.9163 6.63477 33.5013 6.38574 32.9414 6.38574C32.4987 6.38574 32.1536 6.55664 31.9062 6.89844C31.6589 7.24023 31.5352 7.74642 31.5352 8.41699ZM40.2021 4.4375V5.7168H41.1885V6.41504H40.2021V9.69141C40.2021 9.90299 40.2461 10.0625 40.334 10.1699C40.4219 10.2741 40.5716 10.3262 40.7832 10.3262C40.8874 10.3262 41.0306 10.3066 41.2129 10.2676V11C40.9753 11.0651 40.7441 11.0977 40.5195 11.0977C40.1159 11.0977 39.8115 10.9756 39.6064 10.7314C39.4014 10.4873 39.2988 10.1406 39.2988 9.69141V6.41504H38.3369V5.7168H39.2988V4.4375H40.2021ZM44.4404 11.0977C43.7243 11.0977 43.1416 10.8633 42.6924 10.3945C42.2432 9.92253 42.0186 9.29264 42.0186 8.50488V8.33887C42.0186 7.81478 42.1178 7.34766 42.3164 6.9375C42.5182 6.52409 42.7982 6.20182 43.1562 5.9707C43.5176 5.73633 43.9082 5.61914 44.3281 5.61914C45.015 5.61914 45.5488 5.84538 45.9297 6.29785C46.3105 6.75033 46.501 7.39811 46.501 8.24121V8.61719H42.9219C42.9349 9.13802 43.0863 9.55957 43.376 9.88184C43.6689 10.2008 44.04 10.3604 44.4893 10.3604C44.8083 10.3604 45.0785 10.2952 45.2998 10.165C45.5212 10.0348 45.7148 9.8623 45.8809 9.64746L46.4326 10.0771C45.9899 10.7575 45.3258 11.0977 44.4404 11.0977ZM44.3281 6.36133C43.9635 6.36133 43.6576 6.49479 43.4102 6.76172C43.1628 7.02539 43.0098 7.39648 42.9512 7.875H45.5977V7.80664C45.5716 7.34766 45.4479 6.99284 45.2266 6.74219C45.0052 6.48828 44.7057 6.36133 44.3281 6.36133ZM50.627 9.59863C50.627 9.35449 50.5342 9.16569 50.3486 9.03223C50.1663 8.89551 49.8457 8.77832 49.3867 8.68066C48.931 8.58301 48.568 8.46582 48.2979 8.3291C48.0309 8.19238 47.8324 8.02962 47.7021 7.84082C47.5752 7.65202 47.5117 7.42741 47.5117 7.16699C47.5117 6.73405 47.694 6.36784 48.0586 6.06836C48.4264 5.76888 48.8952 5.61914 49.4648 5.61914C50.0638 5.61914 50.5488 5.77376 50.9199 6.08301C51.2943 6.39225 51.4814 6.78776 51.4814 7.26953H50.5732C50.5732 7.02214 50.4674 6.80892 50.2559 6.62988C50.0475 6.45085 49.7839 6.36133 49.4648 6.36133C49.1361 6.36133 48.8789 6.43294 48.6934 6.57617C48.5078 6.7194 48.415 6.90658 48.415 7.1377C48.415 7.35579 48.5013 7.52018 48.6738 7.63086C48.8464 7.74154 49.1572 7.84733 49.6064 7.94824C50.0589 8.04915 50.4251 8.1696 50.7051 8.30957C50.985 8.44954 51.1917 8.61882 51.3252 8.81738C51.4619 9.0127 51.5303 9.25195 51.5303 9.53516C51.5303 10.0072 51.3415 10.3864 50.9639 10.6729C50.5863 10.9561 50.0964 11.0977 49.4941 11.0977C49.071 11.0977 48.6966 11.0228 48.3711 10.873C48.0456 10.7233 47.79 10.515 47.6045 10.248C47.4222 9.97786 47.3311 9.68652 47.3311 9.37402H48.2344C48.2507 9.67676 48.3711 9.91764 48.5957 10.0967C48.8236 10.2725 49.123 10.3604 49.4941 10.3604C49.8359 10.3604 50.1094 10.292 50.3145 10.1553C50.5228 10.0153 50.627 9.82975 50.627 9.59863ZM53.9326 4.4375V5.7168H54.9189V6.41504H53.9326V9.69141C53.9326 9.90299 53.9766 10.0625 54.0645 10.1699C54.1523 10.2741 54.3021 10.3262 54.5137 10.3262C54.6178 10.3262 54.7611 10.3066 54.9434 10.2676V11C54.7057 11.0651 54.4746 11.0977 54.25 11.0977C53.8464 11.0977 53.542 10.9756 53.3369 10.7314C53.1318 10.4873 53.0293 10.1406 53.0293 9.69141V6.41504H52.0674V5.7168H53.0293V4.4375H53.9326Z"
      fill="#00447B"
    />
  </svg>
);

export const INBOUND_ICON = (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 1H2C1.73478 1 1.48043 1.10536 1.29289 1.29289C1.10536 1.48043 1 1.73478 1 2V8C1 8.26522 1.10536 8.51957 1.29289 8.70711C1.48043 8.89464 1.73478 9 2 9H8C8.26522 9 8.51957 8.89464 8.70711 8.70711C8.89464 8.51957 9 8.26522 9 8V2C9 1.73478 8.89464 1.48043 8.70711 1.29289C8.51957 1.10536 8.26522 1 8 1H7M5 0.5V4.5M5 4.5L6.5 3M5 4.5L3.5 3M1 5.5H2.293C2.4256 5.50003 2.55275 5.55273 2.6465 5.6465L3.8535 6.8535C3.94725 6.94727 4.0744 6.99997 4.207 7H5.793C5.9256 6.99997 6.05275 6.94727 6.1465 6.8535L7.3535 5.6465C7.44725 5.55273 7.5744 5.50003 7.707 5.5H9"
      stroke="#6E7191"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const INTERNAL_ICON = (
  <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="2.5" cy="2.5" r="2.5" fill="#6E7191" />
  </svg>
);

export const DOUBLE_CHEVRON_LEFT = (
  <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8539 8.14614C10.9003 8.19263 10.9372 8.24782 10.9624 8.30856C10.9875 8.3693 11.0005 8.4344 11.0005 8.50014C11.0005 8.56589 10.9875 8.63099 10.9624 8.69173C10.9372 8.75247 10.9003 8.80766 10.8539 8.85414C10.8074 8.90063 10.7522 8.93751 10.6914 8.96267C10.6307 8.98783 10.5656 9.00077 10.4999 9.00077C10.4341 9.00077 10.369 8.98783 10.3083 8.96267C10.2475 8.93751 10.1923 8.90063 10.1459 8.85414L6.14586 4.85414C6.09929 4.8077 6.06235 4.75252 6.03714 4.69178C6.01194 4.63103 5.99896 4.56591 5.99896 4.50014C5.99896 4.43438 6.01194 4.36926 6.03714 4.30851C6.06235 4.24776 6.09929 4.19259 6.14586 4.14614L10.1459 0.146143C10.1923 0.0996553 10.2475 0.0627792 10.3083 0.0376201C10.369 0.012461 10.4341 -0.000488281 10.4999 -0.000488281C10.5656 -0.000488282 10.6307 0.012461 10.6914 0.0376201C10.7522 0.0627792 10.8074 0.0996553 10.8539 0.146143C10.9003 0.192631 10.9372 0.24782 10.9624 0.30856C10.9875 0.369299 11.0005 0.434399 11.0005 0.500143C11.0005 0.565887 10.9875 0.630987 10.9624 0.691727C10.9372 0.752466 10.9003 0.807655 10.8539 0.854143L7.20686 4.50014L10.8539 8.14614ZM4.85386 8.14614C4.94774 8.24003 5.00049 8.36737 5.00049 8.50014C5.00049 8.63292 4.94774 8.76026 4.85386 8.85414C4.75997 8.94803 4.63263 9.00077 4.49986 9.00077C4.36708 9.00077 4.23974 8.94803 4.14586 8.85414L0.145857 4.85414C0.0992937 4.8077 0.0623512 4.75252 0.0371447 4.69178C0.0119381 4.63103 -0.00103664 4.56591 -0.00103664 4.50014C-0.00103664 4.43438 0.0119381 4.36926 0.0371447 4.30851C0.0623512 4.24776 0.0992937 4.19259 0.145857 4.14614L4.14586 0.146143C4.23974 0.0522566 4.36708 -0.000488281 4.49986 -0.000488281C4.63263 -0.000488281 4.75997 0.0522566 4.85386 0.146143C4.94774 0.24003 5.00049 0.367368 5.00049 0.500143C5.00049 0.632919 4.94774 0.760257 4.85386 0.854143L1.20686 4.50014L4.85386 8.14614Z"
      fill="black"
    />
  </svg>
);

export const PLUS_ICON = (color = 'litlingo-gray-6'): JSX.Element => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-${color}`}
  >
    <path
      d="M1 6.99959L13 7.00041"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.99959 1.00002L7.00041 13"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MINUS_ICON = (color = 'litlingo-gray-6'): JSX.Element => (
  <svg
    width="14"
    height="2"
    viewBox="0 0 14 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-${color}`}
  >
    <path
      d="M1 0.999573L13 1.0004"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ARROW_UP_ICON = (color = 'litlingo-gray-6'): JSX.Element => (
  <svg
    width="15"
    height="10"
    viewBox="0 0 15 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-${color}`}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.50974 4.55608L13.166 10L15 8.08877L7.50965 0.907419L2.00272e-05 8.08877L1.834 10L7.50974 4.55608Z"
      fill="currentColor"
    />
  </svg>
);

export const ARROW_DOWN_ICON = (color = 'litlingo-gray-6'): JSX.Element => (
  <svg
    width="15"
    height="10"
    viewBox="0 0 15 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-${color}`}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.49026 5.44392L1.83398 0L0 1.91123L7.49035 9.09258L15 1.91123L13.166 0L7.49026 5.44392Z"
      fill="currentColor"
    />
  </svg>
);

export const MINUS_ICON_REDESIGN = (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M10.7067 6H1.32031"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PLUS_ICON_REDESIGN = (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M6 0.959961V10.9476"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0665 6H1.08008"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SEARCH_ICON = (color = '#333333'): JSX.Element => (
  <svg width="100%" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.5 14C11.5376 14 14 11.5376 14 8.5C14 5.46243 11.5376 3 8.5 3C5.46243 3 3 5.46243 3 8.5C3 11.5376 5.46243 14 8.5 14Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 17L13 13"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TAG_REMOVE_ICON = (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="5" cy="5" r="5" fill="#ADADAD" />
    <path
      d="M3.56006 3.56L6.47206 6.4724"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.47206 3.56L3.56006 6.4724"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DOWN_ARROW_ICON = (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.49026 8.44392L1.83398 3L0 4.91123L7.49035 12.0926L15 4.91123L13.166 3L7.49026 8.44392Z"
      fill="#333333"
    />
  </svg>
);

export const FILTER_SELECTED_ICON = (color = '#A3E1C1'): JSX.Element => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="8" height="8" rx="4" fill={color} />
  </svg>
);
